// Libraries
import { NgModule } from '@angular/core';

// Routing
import {
  AdminRoutingModule,
  routingComponents
} from './admin.routing';

// Modules
import { SharedModule } from './shared/shared.module';

// Services
import { GlobalSearchService } from './layout/navbar/global-search/global-search.service';

// Components
import { NavbarComponent } from './layout/navbar/navbar.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { GlobalSearchComponent } from './layout/navbar/global-search/global-search.component';

/**
 * `AdminModule` defines a private module that can only be accessed when logged in.
 */
@NgModule({
  imports: [
    SharedModule,
    AdminRoutingModule
  ],
  declarations: [
    routingComponents,
    NavbarComponent,
    SidebarComponent,
    GlobalSearchComponent
  ],
  providers: [
    GlobalSearchService
  ],
})
export class AdminModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/admin.module.ts